// extracted by mini-css-extract-plugin
export default {"video":"styles-module__[local]___fbL1l"};